module.exports = __webpack_public_path__ + "assets/img/king-attack.2600e9c7.png";